/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-16 16:34:17
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { parseStringToArray } from '../utils';
import classnames from 'classnames';
import { getVisual } from '../../../controller';
import { drop,head } from 'lodash';

const defaultColorValue = '#4874cb\n#5cb735\n';

// 换算亿
function convertToBillion(number) {
  const newNumber =  number / 100000000;
  return Math.round(newNumber * 100) / 100;

}

class Form extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      colorValue: defaultColorValue,
      dataset: [],
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }


  componentDidMount () {
    this.loadData();
  }

  loadData = () => {
    const { onChange } = this.props;

    getVisual('36').then(value => {
      const _table = Form.parse(value);
      const _tempColor = Form.parseColor(defaultColorValue);

      this.setState({
        value: value,
        ..._table,
        ..._tempColor
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
        ..._tempColor
      });
    });
  }
  static parse = (str) => {
    const dataset = parseStringToArray(str);
    if (!dataset) return null;
    // const { chartTitle, chartList } = Form.parseChart(drop(dataset, 1));
    const { chartTitle, chartList } = Form.parseChart(dataset);
    return {
      chartTitle,
      chartList,
    }
  }

  static parseChart = (arr) => {
    const seriesTitleArr =  drop(head(arr,1));
    const newArr = drop(arr,1);
    const xAxis = []; // 横轴坐标
    const result = [
      { title: '', list: [] },
      { title: '', list: [] },
    ];

    newArr.forEach(([name, ...data]) => {
      xAxis.push(name);
      data.forEach((val, index) => {
          result[index].list.push(convertToBillion(val));
          // result[index].list.push(val);
          result[index].title =seriesTitleArr[index];
      })
    });
    // console.log(result,xAxis);
    return { chartTitle: xAxis, chartList: result}
  }

  static parseColor = (str) => {
    const chartColorList = parseStringToArray(str);

    return {
      chartColorList: chartColorList.map(([val]) => val)
    }
  }

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = Form.parse(value, this.state.tableColorList);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  onChangeColor = (e) => {
    const { onChange } = this.props;
    const colorValue = e.target.value;
    const _color = Form.parseColor(colorValue);

    this.setState({
      colorValue,
      ..._color,
    })

    typeof onChange === 'function' && onChange(_color)
  }

  render() {
    return (
      <div className={s.root}>
        <div>数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
        <div>颜色设置（颜色只和顺序有关）</div>
        <textarea className={classnames(s.inputText)} value={this.state.colorValue} onChange={this.onChangeColor} />
      </div>
    );
  }
}

export default withStyles(s)(Form);



// WEBPACK FOOTER //
// src/routes/visualChart/P36/Form.js